import {NgModule, Optional, SkipSelf} from '@angular/core';
import {throwIfAlreadyLoaded} from "./module-import-guard";
import {SettingsService} from "./settings/settings.service";
import {ThemesService} from "./themes/themes.service";
import {TranslatorService} from "./translator/translator.service";
import { MenuService } from "./menu/menu.service";
import {GuardService} from "./auth/guard.service";

@NgModule({
    imports: [],
    providers: [
        SettingsService,
        ThemesService,
        TranslatorService,
        MenuService,
        GuardService,
    ],
    exports:[]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
